<div class="wrapper layout-wrapper">
  <div class="layout-sidebar">
    <app-sidebar></app-sidebar>
  </div>
  <div class="layout-content">
    <div class="content-menu">
      <p-menu #profileMenu [model]="profileMenuItems" [popup]="true" appendTo="body"></p-menu>
      <button
        pButton
        class="p-button-icon-only p-button-secondary ml-auto"
        size="small"
        severity="secondary"
        [rounded]="true"
        (click)="profileMenu.toggle($event)"
      >
        <i class="pi pi-user"></i>
      </button>
    </div>
    <div class="content">
      <div class="content-scroll">
        @if (items$ | async; as items) {
          @if (items.length) {
            <div class="page-card mb-2">
              <div class="page-card_content">
                <p-breadcrumb [model]="items"></p-breadcrumb>
              </div>
            </div>
          }
        }

        <router-outlet></router-outlet>
      </div>
    </div>

    <!-- <div class="footer">
      <p class="copyright mr-3">© Cymonz {{ currentYear }}</p>
      <button pButton class="p-button-text p-button-info" (click)="onVersoin()">Version details</button>
    </div> -->
  </div>
  <!-- 
  <div class="layout-mask" (click)="showMenu()"></div> -->

  @if (loaderService.isSpinner()) {
    <p-progressSpinner class="custom-spinner"></p-progressSpinner>
  }

  <p-toast></p-toast>
</div>
